import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { RadSidePanelComponent } from 'app/rad-ui/side-panel/side-panel.component';
import { AdminEditorModule } from 'app/shared/components/admin/admin.module';
import { CurrentTheme } from 'app/shared/model';

// The administration theme editor, held in a panel with no scrim so that the page being themed
// stays on screen and stays usable while its colours are edited.
//
// AdminEditorModule is imported here rather than by the switcher so that a deferred block in the
// switcher's template puts the whole of it in a chunk nobody loads until the panel is opened.
@Component({
    selector: 'key-theme-editor-panel',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AdminEditorModule, RadSidePanelComponent],
    template: `
        <rad-side-panel padding="0" [title]="theme().name" [(open)]="open">
            <key-admin-entity-editor
                class="d-flex flex-stretch flex-column h-100"
                type="theme"
                [company]="theme().owner.id"
                [id]="theme().id"
                (onClose)="open.set(false)"
            ></key-admin-entity-editor>
        </rad-side-panel>
    `,
})
export class KeyThemeEditorPanelComponent {

    /** The theme the editor opens on. Its owner is the company the editor's sections are built for. */
    readonly theme = input.required<CurrentTheme>();

    /** Whether the panel is showing. Two-way, so the switcher is told when the panel closes itself. */
    readonly open = model(false);

}
